/**
 * Created by wjjn3481 on 2017/9/22.
 */
export default {
    data () {
        return {
            lists: [],
            watchRoute: true
        }
    },
    computed: {
        ids () {
            return this.$route.params.ids
        },
        idsLength () {
            return this.ids === -1 ? 0 : this.ids.split(',').length
        }
    },
    watch: {
        $route: function () {
            this.watchRoute && this.fetchList()
        }
    },
    methods: {
        fetchList (url = '/arrangeExam/newArrange.api') {
            if (String(this.ids) === '-1') {
                this.lists = []
                return false
            }
            this.$axios.get(url, {params: {ids: this.ids}}).then(res => {
                this.lists = res.result.list
                this.fetchCallback(res)
            }).catch(console.error)
        },
        fetchCallback (res) {
        },
        removeItem (id) {
            console.log(this.$refs)
            let ids = this.ids.split(',')
            let index = ids.indexOf(id + '')
            ids.splice(index, 1)
            this.$router.replace({
                name: this.$route.name,
                params: {ids: ids.length ? ids.join(',') : -1}
            })
        },
        cancelAndBack () {
            this.$confirm('确定放弃操作，并返回笔试列表？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.replace({name: 'writtenList'})
            }).catch(() => {
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/written/multiMixin.js